module.exports = __webpack_public_path__ + "img/311.d3760899.jpg";